<template>
  <div class="thesis-online-review wrap-content">
    <div class="wrap-inner">
      <div class="wrap-form">
        <Modal
          :closable='false'
          :mask-closable='false'
          v-model="modal"
          title="提示">
          <p>{{msgData}}</p>
          <div slot="footer"><Button  type="primary" size="large" @click="ok">确定</Button></div>
      </Modal>
        <Button :class="curIndex === index ? 'active' : ''" class="g-mr" v-for="(tab, index) in tabList" :key="index" @click="handleClick(tab, index)">{{tab.name}}</Button>
        <label class="form-label g-mt-20">论文在线评阅</label>
        <Form :model="paperReviewInfoDTO" ref="thesisReviewForm" :rules="validateRules">
          <FormItem>
            <Row>
              <Col span="2" style="min-width: 60px;">
                <strong>评阅类型：</strong>
              </Col>
              <Col span="18">
                <label>{{ paperReviewInfoDTO.pylx||'隐名评阅' }}</label>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="2" style="min-width: 60px;"><strong>一级学科：</strong></Col>
              <Col span="18">
                <label>{{ firstSubjectName }}</label>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="2" style="min-width: 60px;"><strong>二级学科：</strong></Col>
              <Col span="18">
                <label>{{ secondSubjectName }}</label>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="2" style="min-width: 60px;"><strong>攻读类别：</strong></Col>
              <Col span="18">
                <label>{{ typeName }}</label>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="2" style="min-width: 60px;"><strong>学习方式：</strong></Col>
              <Col span="18">
                <label>{{ learningStyle }}</label>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="3" style="min-width: 120px;"><strong>论文涉及的研究方向：</strong></Col>
              <Col span="21">
                <label>{{ paperReviewInfoDTO.researchAera }}</label>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="2" style="min-width: 60px;"><strong>中文题目：</strong></Col>
              <Col span="22">
                <label>{{ paperReviewInfoDTO.titleCn }}</label>
                <a v-if='queryData.paperInfo' @click="downloadPaper(queryData.paperInfo)">【学位论文下载】</a>
                <a v-if='queryData.paperInfo' @click="viewPaper(queryData.paperInfo)">【学位论文在线预览】</a>
                <a v-if='queryData.abstractInfo' @click="downloadPaper(queryData.abstractInfo)">【摘要下载】</a>
                <a v-if='queryData.briefInfo' @click="downloadPaper(queryData.briefInfo)">【简况下载】</a>
                <a v-if='queryData.selfInfo' @click="downloadPaper(queryData.selfInfo)">【自评表下载】</a>
              </Col>
            </Row>
          </FormItem>

          <FormItem>
            <Row>
              <Col span="2" style="min-width: 60px;"><strong>英文题目：</strong></Col>
              <Col span="22">
                <label>{{ paperReviewInfoDTO.titleEn }}</label>
              </Col>
            </Row>
          </FormItem>
          <!-- <div class="outer" v-if="outFlag"> -->
          <div v-if="schoolAuditPlanConfigDTO.partJudgeOpen==1">
            <strong>参考评阅要素：</strong>
            <div style="line-height:32px">分项评价<span v-if="schoolAuditPlanConfigDTO.partJudgeComment">({{schoolAuditPlanConfigDTO.partJudgeComment}})</span></div>
            <div v-if="partNameOneBool">
            <FormItem v-for="(item,index) in formItems.slice(0,4)"
                      v-if="!item.filter"
                      :prop="item.name"
                      :key="index"
                      :class="`${item.component == 'select'|| item.type !=='textarea' ? 'inline':'block'} ${item.type =='textarea' ? 'black':''}`"
            >
              <component
                v-model="paperReviewInfoDTO[item.name]"
                :is="getDisplayComponent(item.component)"
                :options="item.options"
                :readonly="item.readonly"
                :type = "item.type"
                :disabled = "item.disabled||allDisable"
                :value = "item.value"
                @on-change="partChange(item)"
              >
              </component>
            </FormItem>
            </div>
            <div v-if="partNameTwoBool">
              <FormItem v-for="(item,index) in formItems.slice(4,8)"
                      v-if="!item.filter"
                      :prop="item.name"
                      :key="index"
                      :class="`${item.component == 'select'|| item.type !=='textarea' ? 'inline':'block'} ${item.type =='textarea' ? 'black':''}`"
              >
                <component
                  v-model="paperReviewInfoDTO[item.name]"
                  :is="getDisplayComponent(item.component)"
                  :options="item.options"
                  :readonly="item.readonly"
                  :type = "item.type"
                  :disabled = "item.disabled||allDisable"
                  :value = "item.value"
                  @on-change="partChange(item)"
                ></component>
              </FormItem>
            </div>
            <div v-if="partNameThreeBool">
            <FormItem v-if="!item.filter" :prop="item.name" v-for="(item,index) in formItems.slice(8,12)"
              :key="index"
            :class="`${item.component == 'select'|| item.type !=='textarea' ? 'inline':'block'} ${item.type =='textarea' ? 'black':''}`"
            >
              <component
                v-model="paperReviewInfoDTO[item.name]"
                :is="getDisplayComponent(item.component)"
                :options="item.options"
                :readonly="item.readonly"
                :type = "item.type"
                :disabled = "item.disabled||allDisable"
                :value = "item.value"
                @on-change="partChange(item)"
              >
              </component>
            </FormItem>
            </div>
            <div v-if="partNameFourBool">
            <FormItem v-if="!item.filter" :prop="item.name" v-for="(item,index) in formItems.slice(12,16)"
              :key="index"
            :class="`${item.component == 'select'|| item.type !=='textarea' ? 'inline':'block'} ${item.type =='textarea' ? 'black':''}`"
            >
              <component
                v-model="paperReviewInfoDTO[item.name]"
                :is="getDisplayComponent(item.component)"
                :options="item.options"
                :readonly="item.readonly"
                :type = "item.type"
                :disabled = "item.disabled||allDisable  "
                :value = "item.value"
                @on-change="partChange(item)"
              >
              </component>
            </FormItem>
            </div>
            <div v-if="partNameFiveBool">
            <FormItem v-if="!item.filter" :prop="item.name" v-for="(item,index) in formItems.slice(16,20)"
              :key="index"
              :class="`${item.component == 'select'|| item.type !=='textarea' ? 'inline':'block'} ${item.type =='textarea' ? 'black':''}`"
            >
              <component
                v-model="paperReviewInfoDTO[item.name]"
                :is="getDisplayComponent(item.component)"
                :options="item.options"
                :readonly="item.readonly"
                :type = "item.type"
                :disabled = "item.disabled||allDisable"
                :value = "item.value"
                @on-change="partChange(item)"
              >
              </component>
            </FormItem>
            </div>
            <div v-if="partNameSixBool">
              <FormItem v-if="!item.filter" :prop="item.name" v-for="(item,index) in formItems.slice(20,24)"
                        :key="index"
                        :class="`${item.component == 'select'|| item.type !=='textarea' ? 'inline':'block'} ${item.type =='textarea' ? 'black':''}`"
              >
                <component
                  v-model="paperReviewInfoDTO[item.name]"
                  :is="getDisplayComponent(item.component)"
                  :options="item.options"
                  :readonly="item.readonly"
                  :type = "item.type"
                  :disabled = "item.disabled||allDisable"
                  :value = "item.value"
                  @on-change="partChange(item)"
                >
                </component>
              </FormItem>
            </div>
            <div v-if="partNameSevenBool">
              <FormItem v-if="!item.filter" :prop="item.name" v-for="(item,index) in formItems.slice(24,28)"
                        :key="index"
                        :class="`${item.component == 'select'|| item.type !=='textarea' ? 'inline':'block'} ${item.type =='textarea' ? 'black':''}`"
              >
                <component
                  v-model="paperReviewInfoDTO[item.name]"
                  :is="getDisplayComponent(item.component)"
                  :options="item.options"
                  :readonly="item.readonly"
                  :type = "item.type"
                  :disabled = "item.disabled||allDisable"
                  :value = "item.value"
                  @on-change="partChange(item)"
                >
                </component>
              </FormItem>
            </div>
          </div>
          <div v-if="schoolAuditPlanConfigDTO.innovationLevel">
            <FormItem prop="innovationOne" style='display:inline-block'>
            <strong>创新点1</strong>
            <Select  :disabled= 'allDisable' clearable  v-model="paperReviewInfoDTO.innovationOne" filterable style="width:200px">
              <Option v-for="(item,index) in schoolAuditPlanConfigDTO.innovationLevelList" :value="item" :key="index">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="innovationTwo" style='display:inline-block'>
            <strong>创新点2</strong>
            <Select :disabled= 'allDisable' clearable  v-model="paperReviewInfoDTO.innovationTwo" filterable style="width:200px">
              <Option v-for="(item,index) in schoolAuditPlanConfigDTO.innovationLevelList" :value="item" :key="index">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="innovationThree"  style='display:inline-block'>
            <strong>创新点3</strong>
            <Select :disabled= 'allDisable' clearable  v-model="paperReviewInfoDTO.innovationThree" filterable style="width:200px">
              <Option v-for="(item,index) in schoolAuditPlanConfigDTO.innovationLevelList" :value="item" :key="index">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem  prop="innovationFour" style='display:inline-block'>
            <strong>创新点4</strong>
            <Select  :disabled= 'allDisable' clearable  v-model="paperReviewInfoDTO.innovationFour" filterable style="width:200px">
              <Option v-for="(item,index) in schoolAuditPlanConfigDTO.innovationLevelList" :value="item" :key="index">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="innovationFive" style='display:inline-block'>
            <strong>创新点5</strong>
            <Select :disabled= 'allDisable' clearable  v-model="paperReviewInfoDTO.innovationFive" filterable style="width:200px">
              <Option v-for="(item,index) in schoolAuditPlanConfigDTO.innovationLevelList" :value="item" :key="index">{{ item }}</Option>
            </Select>
          </FormItem>
          </div>
          <FormItem prop="reviewOpinion" class="g-mt g-mb">
            <strong style="width: 200px;margin-right: 10px">评阅意见（{{schoolAuditPlanConfigDTO.paperComment}}）：</strong>
            <Input style="flex: 1" :disabled= 'allDisable' v-model="paperReviewInfoDTO.reviewOpinion" type="textarea" :autosize="{minRows: 5,maxRows: 20}" placeholder="" :maxlength="1000" @input="countPyyjLength"/>
            <p style="float: right">（{{countPyyj}}/1000字）</p>
          </FormItem>
          <FormItem prop="deficiencies">
            <strong style="width: 200px;margin-right: 10px">不足之处及修改意见（{{schoolAuditPlanConfigDTO.paperShortComing}}）：</strong>
            <Input style="flex: 1" :disabled= 'allDisable' v-model="paperReviewInfoDTO.deficiencies" type="textarea" :autosize="{minRows: 5,maxRows: 20}" placeholder="" :maxlength="1000" @input="countBzzcjxgyjLength"/>
            <p style="float: right">（{{countBzzcjxgyj}}/1000字）</p>
          </FormItem>
          <!-- <FormItem prop="recommendWord" v-if="schoolAuditPlanConfigDTO.recommendReasonOpen==='1' && paperReviewInfoDTO.excellentLevel==='推荐'">
            <Row>
              <Col span="2" style="min-width: 60px;">
                <strong>推荐理由：</strong>
              </Col>
              <Col span="6">
                <Input v-model="paperReviewInfoDTO.recommendWord" type="textarea" :autosize="{minRows: 5,maxRows: 20}" placeholder="" :maxlength="2000"/>
              </Col>
            </Row>
          </FormItem> -->
          <FormItem prop="evaluation">
            <strong>总体评价：<span v-if="schoolAuditPlanConfigDTO.overallComment&&schoolAuditPlanConfigDTO.totalScoreOpen=='1'">{{schoolAuditPlanConfigDTO.overallComment}}：</span></strong>
            <!-- schoolAuditPlanConfigDTO.overallComment?'（'+schoolAuditPlanConfigDTO.overallComment+':'+schoolAuditPlanConfigDTO.totalScoreLevelList[0]+'为优秀'+schoolAuditPlanConfigDTO.totalScoreLevelList[1]+'良好'+schoolAuditPlanConfigDTO.totalScoreLevelList[3]+'及格'+schoolAuditPlanConfigDTO.totalScoreLevelList[4]+'不及格'+'）':'' -->
            <Input v-if="schoolAuditPlanConfigDTO.totalScoreOpen=='1'" :disabled='inputScoreFilter||allDisable' style="width:60px" v-model="paperReviewInfoDTO.score" @on-change="changeScore"/>
            <Select @on-change='showValue'  v-model="paperReviewInfoDTO.evaluation" filterable :disabled="schoolAuditPlanConfigDTO.totalScoreOpen=='1'||allDisable" style="width:200px">
              <Option v-for="(item,index) in schoolAuditPlanConfigDTO.overallJudgeLevelList" :value="item" :key="index">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="reviewResult">
            <strong >答辩决定<span v-if="schoolAuditPlanConfigDTO.replyComment">{{'('+schoolAuditPlanConfigDTO.replyComment + ')'}}</span>：</strong>
            <Select :disabled= 'allDisable' v-model="paperReviewInfoDTO.reviewResult" filterable style="width:200px">
              <Option v-for="(item,index) in schoolAuditPlanConfigDTO.replyLevelList" :value="item" :key="index">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="familiarLevel" v-if="schoolAuditPlanConfigDTO.familiarOpen === '1'">
            <strong style="display:inline">专家对此领域的熟悉程度：</strong>
            <Select style="width:200px" :disabled= 'allDisable' v-model="paperReviewInfoDTO.familiarLevel" filterable>
              <Option v-for="(item,index) in schoolAuditPlanConfigDTO.familiarLevelList" :value="item" :key="index">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="excellentLevel" v-if="schoolAuditPlanConfigDTO.finePaperOpen==='1'&&inclueArr.includes(paperReviewInfoDTO.evaluation)">
            <strong>是否推荐优秀论文{{schoolAuditPlanConfigDTO.recommendWord?'（'+schoolAuditPlanConfigDTO.recommendWord+'）':''}}：</strong>
            <Select :disabled= 'allDisable' v-model="paperReviewInfoDTO.excellentLevel" filterable style="width:200px">
              <Option v-for="(item,index) in schoolAuditPlanConfigDTO.recommendLevelList" :value="item" :key="index">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="description" v-if="schoolAuditPlanConfigDTO.finePaperOpen==='1' && inclueArr.includes(paperReviewInfoDTO.evaluation) && schoolAuditPlanConfigDTO.recommendReasonOpen==='1'&&(paperReviewInfoDTO.excellentLevel==='是'||paperReviewInfoDTO.excellentLevel==='推荐')">
            <strong>推荐理由：</strong>
            <Input :disabled= 'allDisable' v-model="paperReviewInfoDTO.description " type="textarea" :autosize="{minRows: 5,maxRows: 20}" placeholder="" :maxlength="1000" @input="countReasonLength"/>
            <p style="float: right">（{{countReason}}/1000字）</p>
          </FormItem>
          <FormItem prop="signPath" v-if="schoolAuditPlanConfigDTO.reviewSignOpen==='1' ">
            <strong>上传签名：</strong><br>
            <img v-if="uploadImage.demoImage" :src="uploadImage.signURL" style="height: 58px;">
            <Upload
                ref="uploadImage"
                :show-upload-list="false"
                :headers="uploadImage.headers"
                :before-upload="handleBeforeUpload"
                :on-format-error="handleFormatError"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png']"
                type="drag"
                action="/dup/exp/expReviewInfo/uploadReviewSign"
                style="display: inline-block;width:58px;">
              <div style="width: 58px;height:58px;line-height: 58px;">
                <Icon type="ios-camera" size="20"></Icon>
              </div>
            </Upload>
          </FormItem>
        <!-- </div> -->
        </Form>
        <div class="g-ta-c">
          <Button type="primary" v-if="show1" @click="save('1')">接  收</Button>
          <Button type="primary" v-if="show2" @click="save('2')">退  回</Button>
          <Button type="primary" v-if="show3" @click="save('3')">暂存内容</Button>
          <Button type="primary" v-if="show4" @click="save('4')">提交评阅结果</Button>
        </div>
      </div>
      <Modal
          v-model="uploadImage.modal"
          title="签名区域选取"
          @on-ok="postUploadImage"
          @on-cancel="cancel">
        <Alert show-icon>滚动鼠标对签名图片进行缩放</Alert>
        <Button @click="rotateRight">向右旋转90°</Button>
        <Button @click="rotateLeft">向左旋转90°</Button>
        <div class="cropper-content" style="height: 300px;margin-top: 10px;">
          <vueCropper
              v-if="uploadImage.modal"
              ref="cropper"
              :img="uploadImage.option.img"
              :outputSize="uploadImage.option.size"
              :outputType="uploadImage.option.outputType"
              :autoCrop="true"
              :fixedBox="true"
              :autoCropWidth="uploadImage.option.autoCropWidth"
              :autoCropHeight="uploadImage.option.autoCropHeight"
              :fixedNumber="uploadImage.option.number"
              :full="true"
          ></vueCropper>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import ElementInput from '@/components/elements/input'
import ElementSelect from '@/components/elements/select'
export default {
  // 评阅模板
  name: 'thesisOnlineReview',
  components: {ElementInput, ElementSelect},
  props: {
    queryId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      validateRules: {
        reviewOpinion: [{required: true, message: '请填写评阅意见', trigger: 'blur'}],
        deficiencies: [{required: true, message: '请填写不足之处及修改意见', trigger: 'blur'}],
        evaluation: [{required: true, message: '请选择总体评价', trigger: 'change'}],
        familiarLevel: [{required: true, message: '请选择专家对此领域的熟悉程度', trigger: 'change'}],
        excellentLevel: [{required: true, message: '请选择是否推荐优秀论文', trigger: 'change'}],
        // familiarLevel: [{required: true, message: '请填写推荐理由', trigger: 'blur'}],
        innovationOne: [{required: true, message: '请选择创新点一', trigger: 'change'}],
        // innovationTwo: [{required: true, message: '请选择创新点二', trigger: 'blur'}],
        // innovationThree: [{required: true, message: '请选择创新点三', trigger: 'blur'}],
        // innovationFour: [{required: true, message: '请选择创新点四', trigger: 'blur'}],
        // innovationFive: [{required: true, message: '请选择创新点五', trigger: 'blur'}],
        partScoreOne: [{required: true, message: '请选择分项评价', trigger: 'change'}],
        scoreOne: [{required: true, message: '请打分', trigger: 'blur'}],
        partScoreTwo: [{required: true, message: '请选择分项评价', trigger: 'change'}],
        scoreTwo: [{required: true, message: '请打分', trigger: 'blur'}],
        partScoreThree: [{required: true, message: '请选择分项评价', trigger: 'change'}],
        scoreThree: [{required: true, message: '请打分', trigger: 'blur'}],
        partScoreFour: [{required: true, message: '请选择分项评价', trigger: 'change'}],
        scoreFour: [{required: true, message: '请打分', trigger: 'blur'}],
        partScoreFive: [{required: true, message: '请选择分项评价', trigger: 'change'}],
        scoreFive: [{required: true, message: '请打分', trigger: 'blur'}],
        partScoreSix: [{required: true, message: '请选择分项评价', trigger: 'change'}],
        scoreSix: [{required: true, message: '请打分', trigger: 'blur'}],
        partScoreSeven: [{required: true, message: '请选择分项评价', trigger: 'change'}],
        scoreSeven: [{required: true, message: '请打分', trigger: 'blur'}],
        score: [{required: true, message: '请填写总体评价', trigger: 'change'}],
        reviewResult: [{required: true, message: '请选择答辩决定', trigger: 'change'}],
        signPath: [{required: true, message: '请上传签名', trigger: 'change'}]
      },
      msgData: '',
      degreeType: '',
      unitCode: 1,
      countPyyj: 0,
      countReason: 0,
      countBzzcjxgyj: 0,
      show1: true,
      show2: true,
      show3: true,
      show4: true,
      allDisable: false,
      id: '',
      auto: '',
      newSelect: true,
      selfInfoBool: true,
      paperReviewInfoDTO: {},
      // 学校评阅书模板
      schoolAuditPlanConfigDTO: {},
      queryData: {},
      modal: false,
      partNameOneBool: true,
      partNameTwoBool: true,
      partNameThreeBool: true,
      partNameFourBool: true,
      partNameFiveBool: true,
      partNameSixBool: true,
      partNameSevenBool: true,
      inclueArr: [],
      firstSubjectName: '',
      secondSubjectName: '',
      typeName: '',
      learningStyle: '',
      // outFlag: false,
      // readonly: false,
      formItems: [],
      partPercent: [],
      selectScoreFilter: false,
      inputScoreFilter: false,
      inputScoreReadonly: false,
      uploadImage: {
        demoImage: false,
        signURL: null,
        headers: {},
        file: null,
        modal: false,
        option: {
          img: null,
          size: 0.8,
          outputType: 'jpeg',
          autoCropWidth: 150,
          autoCropHeight: 50,
          number: [3, 1]
        }
      },
      tabList: [],
      curIndex: 0
    }
  },
  created () {
    const _self = this;
    _self.id = (_self.$route.query['id']);
    _self.unitCode = (_self.$route.query['unitCode']);
    _self.degreeType = (_self.$route.query['degreeType']);
    _self.auto = (_self.$route.query['auto']);
    // if (this.queryId !== '') {
    //   console.log(this.queryId, 'son')
    //   this.show3 = false
    //   this.show4 = false
    // } else if (_self.id) {
    _self.queryUserInfo()
    _self.queryStatus()
    // this.outFlag = true
    // }
    this.formItems = [
      {name: 'partNameOne', component: 'input', readonly: true},
      {name: 'partScoreOne', component: 'select', options: [], readonly: false, filter: true},
      {name: 'scoreOne', component: 'input', readonly: false, disabled: false, filter: true},
      {name: 'partDetailOne', component: 'input', readonly: true, type: 'textarea'},
      {name: 'partNameTwo', component: 'input', readonly: true},
      {name: 'partScoreTwo', component: 'select', options: [], readonly: false, filter: true},
      {name: 'scoreTwo', component: 'input', readonly: false, disabled: false, filter: true},
      {name: 'partDetailTwo', component: 'input', readonly: true, type: 'textarea'},
      {name: 'partNameThree', component: 'input', readonly: true},
      {name: 'partScoreThree', component: 'select', options: [], readonly: false, filter: true},
      {name: 'scoreThree', component: 'input', readonly: false, disabled: false, filter: true},
      {name: 'partDetailThree', component: 'input', readonly: true, type: 'textarea'},
      {name: 'partNameFour', component: 'input', readonly: true},
      {name: 'partScoreFour', component: 'select', options: [], readonly: false, filter: true},
      {name: 'scoreFour', component: 'input', readonly: false, disabled: false, filter: true},
      {name: 'partDetailFour', component: 'input', readonly: true, type: 'textarea'},
      {name: 'partNameFive', component: 'input', readonly: true},
      {name: 'partScoreFive', component: 'select', options: [], readonly: false, filter: true},
      {name: 'scoreFive', component: 'input', readonly: false, disabled: false, filter: true},
      {name: 'partDetailFive', component: 'input', readonly: true, type: 'textarea'},
      {name: 'partNameSix', component: 'input', readonly: true},
      {name: 'partScoreSix', component: 'select', options: [], readonly: false, filter: true},
      {name: 'scoreSix', component: 'input', readonly: false, disabled: false, filter: true},
      {name: 'partDetailSix', component: 'input', readonly: true, type: 'textarea'},
      {name: 'partNameSeven', component: 'input', readonly: true},
      {name: 'partScoreSeven', component: 'select', options: [], readonly: false, filter: true},
      {name: 'scoreSeven', component: 'input', readonly: false, disabled: false, filter: true},
      {name: 'partDetailSeven', component: 'input', readonly: true, type: 'textarea'}
    ]
    this.uploadImage.headers.token = this.$store.state.user.token;
  },
  activated () {
    const _self = this;
    _self.id = (_self.$route.query['id']);
    _self.unitCode = (_self.$route.query['unitCode']);
    _self.degreeType = (_self.$route.query['degreeType']);
    if (_self.id) {
      _self.queryThesisInfo2();
      _self.queryUserInfo()
    }
    this.countPyyjLength()
    this.countBzzcjxgyjLength()
    this.countReasonLength()
  },
  mounted () {
    this.autoAccept()
    // this.$nextTick(function () {

    // })
    setTimeout(() => {
      this.changeInline(6, 9, 12, 15, 18)
    }, 500);
  },
  methods: {
    handleClick (value, index) {
      this.curIndex = index
      this.fetchDetail(value.id)
    },
    cancel () {
      this.uploadImage.modal = false;
    },
    showValue () {
      this.schoolAuditPlanConfigDTO.replyLevelList = [];
      this.schoolAuditPlanConfigDTO.replyLevelList = this.judgeReplyMap[this.paperReviewInfoDTO.evaluation];
    },
    autoAccept () {
      // typeof (this.$route.query.acceptNum)
      if (this.$route.query.auto) {
        if (this.$route.query.auto === '1' && this.show1) {
          this.save('1')
        }
      }
    },
    ok () {
      this.save('3')
      this.$router.push('/shell/custom/expertManage/expertInfo?back=1')
    },
    fetchExpertInfoByUserId () {
      this.fetch('/exp/expInfo/info/getExpByUserId').then(data => {
        this.fetch('/exp/expInfo/check/' + data.data.id).then(res => {
          // 信息不全
          if (res.msg !== '') {
            this.modal = true
            if (res.msg.indexOf('银行卡') === -1 && res.msg.indexOf('开户') === -1) {
              let allArr = res.msg.split(';')
              this.msgData = allArr.join(',') + '请完善后提交'
            } else {
              let bankCode = res.msg.indexOf('银行卡')
              let bank = res.msg.indexOf('开户')
              let msgArr = res.msg.split(';')
              // this.msgData = '请先完善您的银行卡号和开户行后再提交，以便及时向您邮寄评审费用'
              if (bankCode !== -1 && bank !== -1) {
                this.msgData = '请先完善您的银行卡号和开户行后再提交，以便及时向您邮寄评审费用'
                msgArr.splice(msgArr.indexOf('银行卡号不能为空'), 1)
                let newIndex = msgArr.indexOf('开户行不能为空')
                msgArr.splice(newIndex, 1)
                let otherMsg = msgArr.join(',')
                if (otherMsg) {
                  this.msgData = otherMsg + '请先完善您的银行卡号和开户行后再提交，以便及时向您邮寄评审费用'
                }
              }
              if (bankCode !== -1 && bank === -1) {
                this.msgData = '请先完善您的银行卡号后再提交，以便及时向您邮寄评审费用'
                msgArr.splice(msgArr.indexOf('银行卡号不能为空'), 1)
                let otherMsg = msgArr.join(',')
                if (otherMsg) {
                  this.msgData = otherMsg + '请先完善您的银行卡号后再提交，以便及时向您邮寄评审费用'
                }
              }
              if (bankCode === -1 && bank !== -1) {
                this.msgData = '请先完善您的开户行后再提交，以便及时向您邮寄评审费用'
                msgArr.splice(msgArr.indexOf('开户行不能为空'), 1)
                let otherMsg = msgArr.join(',')
                if (otherMsg) {
                  this.msgData = otherMsg + '请先完善您的开户行后再提交，以便及时向您邮寄评审费用'
                }
              }
            }
          } else {
            let data = { ...this.schoolAuditPlanConfigDTO, ...this.queryData.expReview, ...this.paperReviewInfoDTO }
            data.id = this.queryData.expReview.id
            if (this.paperReviewInfoDTO.partScoreOne) {
              data.partScoreOne = this.paperReviewInfoDTO.partScoreOne
            } else {
              delete data.partScoreOne
            }
            if (this.paperReviewInfoDTO.partScoreTwo) {
              data.partScoreTwo = this.paperReviewInfoDTO.partScoreTwo
            } else {
              delete data.partScoreTwo
            }
            if (this.paperReviewInfoDTO.partScoreThree) {
              data.partScoreThree = this.paperReviewInfoDTO.partScoreThree
            } else {
              delete data.partScoreThree
            }
            if (this.paperReviewInfoDTO.partScoreFour) {
              data.partScoreFour = this.paperReviewInfoDTO.partScoreFour
            } else {
              delete data.partScoreFour
            }
            if (this.paperReviewInfoDTO.partScoreFive) {
              data.partScoreFive = this.paperReviewInfoDTO.partScoreFive
            } else {
              delete data.partScoreFive
            }
            if (this.paperReviewInfoDTO.partScoreSix) {
              data.partScoreSix = this.paperReviewInfoDTO.partScoreSix
            } else {
              delete data.partScoreSix
            }
            if (this.paperReviewInfoDTO.partScoreSeven) {
              data.partScoreSeven = this.paperReviewInfoDTO.partScoreSeven
            } else {
              delete data.partScoreSeven
            }
            this.post('exp/expReviewInfo/reviewPaper', data).then(res => {
              if (res.code === 200) {
                this.show3 = false
                this.show4 = false
                this.allDisable = true
                this.$Message.success('操作成功！');
              } else {
                this.$Message.warning('操作失败！');
              }
            });
          }
        })
      });
    },
    save (param) {
      const _self = this;
      if (param === '1' || param === '2' || param === '3') {
        if (param === '1') {
          this.show1 = false
          this.show2 = false
          this.queryData.expReview.acceptStatus = '1';
          this.queryData.expReview.reviewStatus = '0';
          this.post('exp/expReviewInfo/receiveOrRejectPaperByExp', this.queryData.expReview).then(res => {
            if (res.code === 200) {
              this.$Message.success('操作成功！');
              this.queryStatus()
            } else {
              this.$Message.warning('操作失败！');
            }
          })
        } else if (param === '2') {
          this.show2 = false
          this.queryData.expReview.acceptStatus = '2';
          this.queryData.expReview.reviewStatus = '0';
          this.post('exp/expReviewInfo/receiveOrRejectPaperByExp', this.queryData.expReview).then(res => {
            if (res.code === 200) {
              this.$Message.success('操作成功！');
              this.$router.push('/shell/regular/returnThesis')
            } else {
              this.$Message.warning('操作失败！');
            }
          })
        } else if (param === '3') {
          if (this.paperReviewInfoDTO.acceptStatus === '1') {
            this.paperReviewInfoDTO.reviewStatus = '1';
            let data = { ...this.schoolAuditPlanConfigDTO, ...this.queryData.expReview, ...this.paperReviewInfoDTO }
            data.id = this.queryData.expReview.id
            this.post('exp/expReviewInfo/reviewPaper', data).then(res => {
              if (res.code === 200) {
                this.$Message.success('操作成功！');
              } else {
                this.$Message.warning('操作失败！');
              }
            })
          } else {
            this.$Message.warning('论文还未接收，无法暂存内容！');
            return false;
          }
        }
      } else {
        _self.$refs['thesisReviewForm'].validate((valid) => {
          if (valid) {
            if (param === '4') {
              if (this.paperReviewInfoDTO.acceptStatus === '1') {
                // 提交时，判断整体评价是否是最后一级
                if (_self.paperReviewInfoDTO.evaluation === _self.schoolAuditPlanConfigDTO.overallJudgeLevelList[_self.schoolAuditPlanConfigDTO.overallJudgeLevelList.length - 1]) {
                  // 判断不足内容字符长度是否超过200
                  if (_self.paperReviewInfoDTO.deficiencies.length < 200) {
                    this.$Message.warning({content: `学生论文总体评价为${_self.paperReviewInfoDTO.evaluation}，请在不足之处和修改意见填写至少200字，谢谢！`, duration: 5});
                    return false;
                  }
                }
                this.paperReviewInfoDTO.reviewStatus = '2';
              } else {
                this.$Message.warning('论文还未接收，无法提交评阅结果！');
                return false;
              }
            }
            this.checkInfo()
          } else {
          }
        })
      }
    },
    checkInfo () {
      this.fetchExpertInfoByUserId()
    },
    changeInline (...arg) {
      if (this.schoolAuditPlanConfigDTO.partJudgeOpen === 1) {
        arg.forEach(element => {
          document.getElementsByClassName('kh-form-item')[element].style.cssText = 'display:inline-block;margin-right:10px'
        })
      }
    },
    queryUserInfo () {
      this.fetch('/conf/confDegreeType/info/' + this.degreeType).then(res => {
        if (res.data && (res.data.name === '博士学位' || res.data.name === '专业博士学位')) {
          this.newSelect = true
        }
      })
    },
    queryStatus () {
      this.fetch('/exp/expReviewInfo/selectCollectionInfoByPaperId/' + this.id).then(res => {
        this.tabList = res.data
        this.fetchDetail(this.tabList[0].id)
        this.paperReviewInfoDTO.acceptStatus = res.data.reviewFlowDTO.acceptStatus
        if (res.data.reviewFlowDTO.acceptStatus !== '2') {
          this.show1 = false
          this.show2 = false
        }
      })
    },
    fetchDetail (expId) {
      // 根据id查询论文信息
      let searchParam = new URLSearchParams();
      searchParam.append('paperId', this.$route.query['id']);
      searchParam.append('expId', expId);
      this.post('/exp/expReviewInfo/selectCollectionInfoByExpIdAndPaperId', searchParam).then(res => {
        if (res.code === 200) {
          this.queryData = res.data
          this.inclueArr = res.data.schoolAuditPlanConfigDTO.overallJudgeLevelList.slice(0, 3)
          if (res.data.expReview.acceptStatus === '1') {
            this.show1 = false
            this.show2 = false
          }
          if (res.data.expReview.reviewStatus === '2') {
            this.show1 = false
            this.show2 = false
            this.show3 = false
            this.show4 = false
            this.allDisable = true
          }
          this.firstSubjectName = res.data.paperBaseInfo.firstSubjectName
          this.secondSubjectName = res.data.paperBaseInfo.secondSubjectName
          this.typeName = res.data.paperBaseInfo.typeName
          this.learningStyle = res.data.paperBaseInfo.learningStyle
          if (typeof (this.paperReviewInfoDTO.score) === 'undefined') {
          }
          this.paperReviewInfoDTO = {...res.data.expReview, ...res.data.paperBaseInfo, ...res.data.abstractInfo, ...res.data.expInfoEntity, ...res.data.paperInfo}
          let _self = this
          this.paperReviewInfoDTO.unitCode = _self.unitCode
          this.paperReviewInfoDTO.degreeType = this.degreeType
          // this.post('/exp/expReviewInfo/selectCollectionInfoByPaperId/' + this.id).then(res => {
          if (res.code === 200) {
            // 判断是否有签名数据
            if (res.data.signInfoDTO) {
              this.uploadImage.demoImage = true;
              this.uploadImage.signURL = res.data.signInfoDTO.url;
            }
            this.schoolAuditPlanConfigDTO = {...res.data.schoolAuditPlanConfigDTO, ...this.queryData.expReview}
            if (typeof (res.data.schoolAuditPlanConfigDTO.innovationLevel) === 'undefined') {
              delete this.schoolAuditPlanConfigDTO.innovationLevel
            }
            this.judgeReplyMap = JSON.parse(res.data.schoolAuditPlanConfigDTO.judgeReplyMap)
            this.countPyyjLength()
            this.countBzzcjxgyjLength()
            this.countReasonLength()
            this.blurScore(this.queryData.expReview.score)

            if ((_self.schoolAuditPlanConfigDTO.partJudgeMode === '1' || (_self.schoolAuditPlanConfigDTO.partJudgeMode === '2' && _self.schoolAuditPlanConfigDTO.convertScoreOpen === '1'))) {
              _self.paperReviewInfoDTO.partNameOne = _self.schoolAuditPlanConfigDTO.partNameOne + '(' + _self.schoolAuditPlanConfigDTO.partScoresOne + '分)'
              _self.paperReviewInfoDTO.partNameTwo = _self.schoolAuditPlanConfigDTO.partNameTwo + '(' + _self.schoolAuditPlanConfigDTO.partScoresTwo + '分)'
              _self.paperReviewInfoDTO.partNameThree = _self.schoolAuditPlanConfigDTO.partNameThree + '(' + _self.schoolAuditPlanConfigDTO.partScoresThree + '分)'
              _self.paperReviewInfoDTO.partNameFour = _self.schoolAuditPlanConfigDTO.partNameFour + '(' + _self.schoolAuditPlanConfigDTO.partScoresFour + '分)'
              _self.paperReviewInfoDTO.partNameFive = _self.schoolAuditPlanConfigDTO.partNameFive + '(' + _self.schoolAuditPlanConfigDTO.partScoresFive + '分)'
              _self.paperReviewInfoDTO.partNameSix = _self.schoolAuditPlanConfigDTO.partNameSix + '(' + _self.schoolAuditPlanConfigDTO.partScoresSix + '分)'
              _self.paperReviewInfoDTO.partNameSeven = _self.schoolAuditPlanConfigDTO.partNameSeven + '(' + _self.schoolAuditPlanConfigDTO.partScoresSeven + '分)'
              _self.partPercent = [_self.schoolAuditPlanConfigDTO.partScoresOne, _self.schoolAuditPlanConfigDTO.partScoresTwo, _self.schoolAuditPlanConfigDTO.partScoresThree, _self.schoolAuditPlanConfigDTO.partScoresFour, _self.schoolAuditPlanConfigDTO.partScoresFive, _self.schoolAuditPlanConfigDTO.partScoresSix, _self.schoolAuditPlanConfigDTO.partScoresSeven];
            } else {
              this.paperReviewInfoDTO.partNameOne = this.schoolAuditPlanConfigDTO.partNameOne
              this.paperReviewInfoDTO.partNameTwo = this.schoolAuditPlanConfigDTO.partNameTwo
              this.paperReviewInfoDTO.partNameThree = this.schoolAuditPlanConfigDTO.partNameThree
              this.paperReviewInfoDTO.partNameFour = this.schoolAuditPlanConfigDTO.partNameFour
              this.paperReviewInfoDTO.partNameFive = this.schoolAuditPlanConfigDTO.partNameFive
              this.paperReviewInfoDTO.partNameSix = this.schoolAuditPlanConfigDTO.partNameSix
              this.paperReviewInfoDTO.partNameSeven = this.schoolAuditPlanConfigDTO.partNameSeven
            }

            this.paperReviewInfoDTO.partDetailOne = this.schoolAuditPlanConfigDTO.partDetailOne
            this.paperReviewInfoDTO.partDetailTwo = this.schoolAuditPlanConfigDTO.partDetailTwo
            this.paperReviewInfoDTO.partDetailThree = this.schoolAuditPlanConfigDTO.partDetailThree
            this.paperReviewInfoDTO.partDetailFour = this.schoolAuditPlanConfigDTO.partDetailFour
            this.paperReviewInfoDTO.partDetailFive = this.schoolAuditPlanConfigDTO.partDetailFive
            this.paperReviewInfoDTO.partDetailSix = this.schoolAuditPlanConfigDTO.partDetailSix
            this.paperReviewInfoDTO.partDetailSeven = this.schoolAuditPlanConfigDTO.partDetailSeven

            _self.selectScoreFilter = _self.schoolAuditPlanConfigDTO.partJudgeMode === '2';
            _self.inputScoreFilter = (_self.schoolAuditPlanConfigDTO.partJudgeMode === '1' || (_self.schoolAuditPlanConfigDTO.partJudgeMode === '2' && _self.schoolAuditPlanConfigDTO.convertScoreOpen === '1'));
            _self.inputScoreReadonly = _self.schoolAuditPlanConfigDTO.partJudgeMode === '2' && _self.schoolAuditPlanConfigDTO.convertScoreOpen === '1'

            if (res.data.schoolAuditPlanConfigDTO.partJudgeOpen === '1') {
              if (typeof (res.data.schoolAuditPlanConfigDTO.partNameOne) === 'undefined') {
                this.partNameOneBool = false
              } else {
                this.partNameOneBool = true
              }
              if (typeof (res.data.schoolAuditPlanConfigDTO.partNameTwo) === 'undefined') {
                this.partNameTwoBool = false
              } else {
                this.partNameTwoBool = true
              }
              if (typeof (res.data.schoolAuditPlanConfigDTO.partNameThree) === 'undefined') {
                this.partNameThreeBool = false
              } else {
                this.partNameThreeBool = true
              }
              if (typeof (res.data.schoolAuditPlanConfigDTO.partNameFour) === 'undefined') {
                this.partNameFourBool = false
              } else {
                this.partNameFourBool = true
              }
              if (typeof (res.data.schoolAuditPlanConfigDTO.partNameFive) === 'undefined') {
                this.partNameFiveBool = false
              } else {
                this.partNameFiveBool = true
              }
              if (typeof (res.data.schoolAuditPlanConfigDTO.partNameSix) === 'undefined') {
                this.partNameSixBool = false
              } else {
                this.partNameSixBool = true
              }
              if (typeof (res.data.schoolAuditPlanConfigDTO.partNameSeven) === 'undefined') {
                this.partNameSevenBool = false
              } else {
                this.partNameSevenBool = true
              }
              let partJudgeLevelList = res.data.schoolAuditPlanConfigDTO.partJudgeLevelList;
              if (partJudgeLevelList) {
                let convertScoreRate = res.data.schoolAuditPlanConfigDTO.convertScoreRate ? res.data.schoolAuditPlanConfigDTO.convertScoreRate.split('|') : [];
                if (_self.inputScoreReadonly) {
                  if (partJudgeLevelList.length === convertScoreRate.length) {
                    for (let i = 0; i < partJudgeLevelList.length; i++) {
                      _self.formItems.forEach(item => {
                        if (['partScoreOne', 'partScoreTwo', 'partScoreThree', 'partScoreFour', 'partScoreFive', 'partScoreSix', 'partScoreSeven'].includes(item.name)) {
                          item.options.push({value: partJudgeLevelList[i], name: convertScoreRate[i], label: partJudgeLevelList[i]})
                        }
                      });
                    }
                  } else {
                    _self.$Message.error('评阅模板分项打分配置出错');
                    return;
                  }
                } else if (_self.selectScoreFilter) {
                  partJudgeLevelList.forEach(element => {
                    this.formItems.forEach(item => {
                      if (item.component === 'select') {
                        item.options.push({value: element, name: element, label: element})
                      }
                    });
                  })
                }
              }
            }

            _self.formItems[0].value = res.data.schoolAuditPlanConfigDTO.partNameOne
            _self.formItems[1].filter = !_self.selectScoreFilter
            _self.formItems[2].filter = !_self.inputScoreFilter
            _self.formItems[2].disabled = _self.inputScoreReadonly
            _self.formItems[3].value = res.data.schoolAuditPlanConfigDTO.partDetailOne
            _self.formItems[4].value = res.data.schoolAuditPlanConfigDTO.partNameTwo
            _self.formItems[5].filter = !_self.selectScoreFilter
            _self.formItems[6].filter = !_self.inputScoreFilter
            _self.formItems[6].disabled = _self.inputScoreReadonly
            _self.formItems[7].value = res.data.schoolAuditPlanConfigDTO.partDetailTwo
            _self.formItems[8].value = res.data.schoolAuditPlanConfigDTO.partNameThree
            _self.formItems[9].filter = !_self.selectScoreFilter
            _self.formItems[10].filter = !_self.inputScoreFilter
            _self.formItems[10].disabled = _self.inputScoreReadonly
            _self.formItems[11].value = res.data.schoolAuditPlanConfigDTO.partDetailThree
            _self.formItems[12].value = res.data.schoolAuditPlanConfigDTO.partNameFour
            _self.formItems[13].filter = !_self.selectScoreFilter
            _self.formItems[14].filter = !_self.inputScoreFilter
            _self.formItems[14].disabled = _self.inputScoreReadonly
            _self.formItems[15].value = res.data.schoolAuditPlanConfigDTO.partDetailFour
            _self.formItems[16].value = res.data.schoolAuditPlanConfigDTO.partNameFive
            _self.formItems[17].filter = !_self.selectScoreFilter
            _self.formItems[18].filter = !_self.inputScoreFilter
            _self.formItems[18].disabled = _self.inputScoreReadonly
            _self.formItems[19].value = res.data.schoolAuditPlanConfigDTO.partDetailFive
            _self.formItems[20].value = res.data.schoolAuditPlanConfigDTO.partNameSix
            _self.formItems[21].filter = !_self.selectScoreFilter
            _self.formItems[22].filter = !_self.inputScoreFilter
            _self.formItems[22].disabled = _self.inputScoreReadonly
            _self.formItems[23].value = res.data.schoolAuditPlanConfigDTO.partDetailSix
            _self.formItems[24].value = res.data.schoolAuditPlanConfigDTO.partNameSeven
            _self.formItems[25].filter = !_self.selectScoreFilter
            _self.formItems[26].filter = !_self.inputScoreFilter
            _self.formItems[26].disabled = _self.inputScoreReadonly
            _self.formItems[27].value = res.data.schoolAuditPlanConfigDTO.partDetailSeven
          }
          // });
          // this.autoAccept()
        } else {
          this.$Message.error('获取数据失败！');
        }
      });
    },
    queryThesisInfo2 () {
      // 根据id查询论文信息
      this.fetch('/exp/expReviewInfo/selectCollectionInfoByPaperId/' + this.id).then(res => {
        if (res.code === 200) {
          if (typeof (res.data.selfInfo) === 'undefined') {
            this.selfInfoBool = false
          }
          this.queryData = res.data
          if (res.data.expReview.acceptStatus === '1') {
            this.show1 = false
            this.show2 = false
          }
          if (res.data.expReview.reviewStatus === '2') {
            this.show1 = false
            this.show2 = false
            this.show3 = false
            this.show4 = false
            this.allDisable = true
          }
          this.firstSubjectName = res.data.paperBaseInfo.firstSubjectName
          this.secondSubjectName = res.data.paperBaseInfo.secondSubjectName
          this.typeName = res.data.paperBaseInfo.typeName
          this.learningStyle = res.data.paperBaseInfo.learningStyle
          if (typeof (this.paperReviewInfoDTO.score) === 'undefined') {
          }
          this.paperReviewInfoDTO = {...res.data.expReview, ...res.data.paperBaseInfo, ...res.data.abstractInfo, ...res.data.expInfoEntity, ...res.data.paperInfo}
          let _self = this
          this.paperReviewInfoDTO.unitCode = _self.unitCode
          this.paperReviewInfoDTO.degreeType = this.degreeType
          // change a
          // this.post('/exp/expReviewInfo/selectCollectionInfoByPaperId/' + this.id).then(res => {
          if (res.code === 200) {
            this.schoolAuditPlanConfigDTO = res.data.schoolAuditPlanConfigDTO
            // 判断是否有签名数据
            if (res.data.signInfoDTO) {
              this.uploadImage.demoImage = true;
              this.uploadImage.signURL = res.data.signInfoDTO.url;
            }

            this.judgeReplyMap = JSON.parse(res.data.schoolAuditPlanConfigDTO.judgeReplyMap)
            this.countPyyjLength()
            this.countBzzcjxgyjLength()
            this.countReasonLength()
            if (res.data.schoolAuditPlanConfigDTO.partJudgeOpen === '1') {
              this.partNameOneBool = typeof (res.data.schoolAuditPlanConfigDTO.partNameOne) !== 'undefined';
              this.partNameTwoBool = typeof (res.data.schoolAuditPlanConfigDTO.partNameTwo) !== 'undefined';
              this.partNameThreeBool = typeof (res.data.schoolAuditPlanConfigDTO.partNameThree) !== 'undefined';
              this.partNameFourBool = typeof (res.data.schoolAuditPlanConfigDTO.partNameFour) !== 'undefined';
              this.partNameFiveBool = typeof (res.data.schoolAuditPlanConfigDTO.partNameFive) !== 'undefined';
              this.partNameSixBool = typeof (res.data.schoolAuditPlanConfigDTO.partNameSix) !== 'undefined';
              this.partNameSevenBool = typeof (res.data.schoolAuditPlanConfigDTO.partNameSeven) !== 'undefined';
            }
            _self.selectScoreFilter = _self.schoolAuditPlanConfigDTO.partJudgeMode === '2';
            _self.inputScoreFilter = (_self.schoolAuditPlanConfigDTO.partJudgeMode === '1' || (_self.schoolAuditPlanConfigDTO.partJudgeMode === '2' && _self.schoolAuditPlanConfigDTO.convertScoreOpen === '1'));
            _self.inputScoreReadonly = _self.schoolAuditPlanConfigDTO.partJudgeMode === '2' && _self.schoolAuditPlanConfigDTO.convertScoreOpen === '1'

            _self.formItems[0].value = res.data.schoolAuditPlanConfigDTO.partNameOne
            _self.formItems[1].filter = !_self.selectScoreFilter
            _self.formItems[2].filter = !_self.inputScoreFilter
            _self.formItems[2].disabled = _self.inputScoreReadonly
            _self.formItems[3].value = res.data.schoolAuditPlanConfigDTO.partDetailOne
            _self.formItems[4].value = res.data.schoolAuditPlanConfigDTO.partNameTwo
            _self.formItems[5].filter = !_self.selectScoreFilter
            _self.formItems[6].filter = !_self.inputScoreFilter
            _self.formItems[6].disabled = _self.inputScoreReadonly
            _self.formItems[7].value = res.data.schoolAuditPlanConfigDTO.partDetailTwo
            _self.formItems[8].value = res.data.schoolAuditPlanConfigDTO.partNameThree
            _self.formItems[9].filter = !_self.selectScoreFilter
            _self.formItems[10].filter = !_self.inputScoreFilter
            _self.formItems[10].disabled = _self.inputScoreReadonly
            _self.formItems[11].value = res.data.schoolAuditPlanConfigDTO.partDetailThree
            _self.formItems[12].value = res.data.schoolAuditPlanConfigDTO.partNameFour
            _self.formItems[13].filter = !_self.selectScoreFilter
            _self.formItems[14].filter = !_self.inputScoreFilter
            _self.formItems[14].disabled = _self.inputScoreReadonly
            _self.formItems[15].value = res.data.schoolAuditPlanConfigDTO.partDetailFour
            _self.formItems[16].value = res.data.schoolAuditPlanConfigDTO.partNameFive
            _self.formItems[17].filter = !_self.selectScoreFilter
            _self.formItems[18].filter = !_self.inputScoreFilter
            _self.formItems[18].disabled = _self.inputScoreReadonly
            _self.formItems[19].value = res.data.schoolAuditPlanConfigDTO.partDetailFive
            _self.formItems[20].value = res.data.schoolAuditPlanConfigDTO.partNameSix
            _self.formItems[21].filter = !_self.selectScoreFilter
            _self.formItems[22].filter = !_self.inputScoreFilter
            _self.formItems[22].disabled = _self.inputScoreReadonly
            _self.formItems[23].value = res.data.schoolAuditPlanConfigDTO.partDetailSix
            _self.formItems[24].value = res.data.schoolAuditPlanConfigDTO.partNameSeven
            _self.formItems[25].filter = !_self.selectScoreFilter
            _self.formItems[26].filter = !_self.inputScoreFilter
            _self.formItems[26].disabled = _self.inputScoreReadonly
            _self.formItems[27].value = res.data.schoolAuditPlanConfigDTO.partDetailSeven
          }
          // });
        } else {
          this.$Message.error('获取数据失败！');
        }
      });
    },
    countPyyjLength () {
      if (this.paperReviewInfoDTO.reviewOpinion) {
        this.countPyyj = this.paperReviewInfoDTO.reviewOpinion.length;
      }
    },
    countBzzcjxgyjLength () {
      if (this.paperReviewInfoDTO.deficiencies) {
        this.countBzzcjxgyj = this.paperReviewInfoDTO.deficiencies.length;
      }
    },
    countReasonLength () {
      if (this.paperReviewInfoDTO.description) {
        this.countReason = this.paperReviewInfoDTO.description.length
      }
    },
    downloadPaper (arg) {
      // 根据id下载论文
      this.fetch('/paper/fileInfo/downloadFile/' + arg.id).then(res => {
        let url = res.data
        setTimeout(() => {
          window.open(url)
        }, 500);
      });
    },
    // 在线预览
    viewPaper (arg) {
      this.fetch('/paper/fileInfo/downloadFile/' + arg.id).then(res => {
        let url = res.data;
        this.$router.push({path: '/shell/custom/thesisManage/viewer', query: {url: url}});
      });
    },
    changeScore (val) {
      const _self = this;
      let result = _self.paperReviewInfoDTO.score;
      if (isNaN(Number(_self.paperReviewInfoDTO.score))) {
        result = _self.paperReviewInfoDTO.score.length === 1 ? '' : _self.paperReviewInfoDTO.score.substr(0, _self.paperReviewInfoDTO.score.length - 1); ;
        // 如果规定为数字类型，不能输入非数字内容
        _self.$nextTick(function () {
          _self.paperReviewInfoDTO.score = _self.paperReviewInfoDTO.score.length === 1 ? '' : _self.paperReviewInfoDTO.score.substr(0, _self.paperReviewInfoDTO.score.length - 1);
        });
      } else {
        if (Number(_self.paperReviewInfoDTO.score) < 0) {
          result = 0
          _self.$nextTick(function () {
            _self.paperReviewInfoDTO.score = '0';
          });
        } else if (_self.paperReviewInfoDTO.score > 100) {
          result = 100;
          _self.$nextTick(function () {
            _self.paperReviewInfoDTO.score = '100';
          });
        }
      }
      _self.blurScore(result);
    },
    blurScore (val) {
      if (val === '') {
        this.paperReviewInfoDTO.evaluation = '';
        this.schoolAuditPlanConfigDTO.replyLevelList = [];
      } else {
        val = Number(val);
        for (let index in this.schoolAuditPlanConfigDTO.totalScoreLevelList) {
          let score = Number(this.schoolAuditPlanConfigDTO.totalScoreLevelList[index]);
          if (Number(index) === this.schoolAuditPlanConfigDTO.totalScoreLevelList.length - 1) {
            if (val < score) {
              this.paperReviewInfoDTO.evaluation = this.schoolAuditPlanConfigDTO.overallJudgeLevelList[index];
              break;
            } else if (val >= score) {
              this.paperReviewInfoDTO.evaluation = this.schoolAuditPlanConfigDTO.overallJudgeLevelList[index - 1];
              break;
            }
          } else {
            if (val >= score) {
              this.paperReviewInfoDTO.evaluation = index - 1 >= 0 ? this.schoolAuditPlanConfigDTO.overallJudgeLevelList[index - 1] : this.schoolAuditPlanConfigDTO.overallJudgeLevelList[index];
              break;
            }
          }
        }
        this.schoolAuditPlanConfigDTO.replyLevelList = this.judgeReplyMap[this.paperReviewInfoDTO.evaluation];
      }
    },
    getDisplayComponent (display) {
      return 'Element' + display.replace(display.charAt(0), display.charAt(0).toUpperCase());
    },
    partChange (item) {
      const _self = this;
      let order = ['partScoreOne', 'partScoreTwo', 'partScoreThree', 'partScoreFour', 'partScoreFive', 'partScoreSix', 'partScoreSeven'].indexOf(item.name);
      let map = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven'];

      if (item.name.startsWith('score')) {
        // 判断输入的是否是number
        if (isNaN(Number(_self.paperReviewInfoDTO[item.name]))) {
          _self.$nextTick(function () {
            _self.paperReviewInfoDTO[item.name] = _self.paperReviewInfoDTO[item.name].length === 1 ? '' : _self.paperReviewInfoDTO[item.name].substr(0, _self.paperReviewInfoDTO[item.name].length - 1);
            _self.paperReviewInfoDTO[item.name] = (_self.paperReviewInfoDTO[item.name] + '').trim();
          });
          return;
        }
        // 如果是直接打分
        for (let i = 0; i < map.length; i++) {
          if (('score' + map[i]) === item.name) {
            order = i;
            break;
          }
        }
        if (Number(_self.paperReviewInfoDTO[item.name]) > Number(_self.partPercent[order])) {
          _self.$nextTick(function () {
            _self.paperReviewInfoDTO[item.name] = _self.paperReviewInfoDTO[item.name].length === 1 ? '' : _self.paperReviewInfoDTO[item.name].substr(0, _self.paperReviewInfoDTO[item.name].length - 1);
            _self.paperReviewInfoDTO[item.name] = (_self.paperReviewInfoDTO[item.name] + '').trim();
          });
          return;
        }
      } else if (order > -1 && _self.inputScoreReadonly) {
        // 分数是计算出来的
        let percent = parseFloat((item.options.filter(i => { return i.value === _self.paperReviewInfoDTO[item.name]; })[0] || {name: 0}).name) / 100;
        _self.paperReviewInfoDTO['score' + map[order]] = (percent * _self.partPercent[order]).toFixed(2);
      }

      if (_self.schoolAuditPlanConfigDTO.totalScoreOpen === '1') {
        if ((order > -1 || item.name.startsWith('score')) && _self.inputScoreFilter) {
          // 可以打分，总分直接计算出来
          let total = 0;
          for (let i of map) {
            total = total + parseFloat(_self.paperReviewInfoDTO['score' + i] || 0);
          }
          _self.paperReviewInfoDTO.score = total.toFixed(2);
          _self.changeScore();
        }
      }
    },
    handleFormatError (file) {
      this.$Message.warning({
        content: file.name + '文件类型不符合要求，请选择\'jpg\',\'jpeg\',\'png\'文件',
        duration: 5
      });
    },
    handleBeforeUpload (file) {
      this.uploadImage.file = file;
      const _self = this;
      let reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result;
        }
        _self.uploadImage.option.img = data;
        _self.uploadImage.modal = true;
      }
      // 转化为blob
      reader.readAsArrayBuffer(file);
      return false;
    },
    postUploadImage () {
      const _self = this;
      _self.$refs.cropper.getCropBlob((data) => {
        let formData = new FormData();
        // let name = _self.uploadImage.file.name;
        // const file = new File([data], name, {type: data.type, lastModified: Date.now()});
        // console.log(JSON.stringify(data));
        formData.append('signData', data);
        formData.append('suffix', '.jpeg');
        _self.post('/exp/expReviewInfo/uploadReviewSign', formData).then(res => {
          _self.$Message.success({
            content: '签名上传成功',
            duration: 5
          });
          _self.uploadImage.demoImage = true;
          _self.paperReviewInfoDTO.signPath = res.data.signPath;
          _self.uploadImage.signURL = res.data.url;
          _self.uploadImage.file = null;
          _self.uploadImage.modal = false;
        });
      });
    },
    rotateRight () {
      const _self = this;
      _self.$refs.cropper.rotateRight();
    },
    rotateLeft () {
      const _self = this;
      _self.$refs.cropper.rotateLeft();
    },
    // 弃用
    handleSuccess (response) {
      if (response.code === 200) {
        this.$Message.success({
          content: '签名上传成功',
          duration: 5
        });
        this.uploadImage.demoImage = true;
        this.paperReviewInfoDTO.signPath = response.data.signPath;
        this.uploadImage.signURL = response.data.url;
        this.uploadImage.file = null;
      } else {
        this.$store.commit('showErrorMsg', {errMsg: response.msg, url: response.data});
      }
    }
  }
}
</script>

<style lang="less">
</style>
<style lang="less" scoped>
  .thesis-online-review{
    overflow: auto;
    /deep/.inline{
      // width: 5%;
      display: inline-block;
      // display: inline-block
    }
    .block{
      display: block;
      padding: 0 6px;
    }
    .inline{
      padding: 0 6px 0 0;
    }
    .black{
      background: @normal-color;
      border-radius: @border-radius-base
    }
    /deep/.kh-select-input[disabled], /deep/.kh-input-disabled{
      color: #515a6e
    }
    .active {
      color: #fff;
      background-color: #2d8cf0;
      border-color: #2d8cf0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/customPage/customerThesis/thesisOnlineReview.vue